import { Autocomplete } from '@trackman/web-shared-components';
import React from 'react';
import styled, { css } from 'styled-components';
import { warningred } from 'styles/Colors';

export const CustomSelectContainer = styled.div<{ error?: boolean }>`
  height: 60px;
  background: #f5f5f5;
  border-radius: 4px;
  border-bottom: solid 4px #a0a0a0;

  ${(props) =>
    props.error &&
    css`
      &&& {
        .MuiInputBase-root {
          border-bottom: 4px solid #ee1b34;
        }
        .MuiFormLabel-root {
          color: #ee1b34;
        }
      }
    `}

  .ReactSelect__control {
    border-bottom: none !important;
    .ReactSelect__placeholder {
      font-family: Lato;
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 21px;
      color: #a0a0a0;
    }
    .ReactSelect__dropdown-indicator {
      width: 30px !important;
      height: 27px !important;
      color: #414141 !important;
    }
  }
`;

export const CustomDescription = styled.div`
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #a0a0a0;
  padding-left: 15px;
  padding-top: 3px;
`;
